export const getToken = (state) => {
  return state.tokenYE
}
